<template>
  <v-container :class="sectionClass">
    <Head title="Hubungi Kami" />
    <h1>Kontak Kami</h1>
  </v-container>
</template>
<script>
import { Head } from '@inertiajs/inertia-vue'
import LayoutHome from '@layouts/Home.vue'
export default {
  name: 'ContactUs',
  components: {
    Head,
  },
  layout: LayoutHome,
}
</script>
